<template>
  <div class="promo-code-input">
    <template v-if="isInitial">
      <div class="promo-code-input__initial-row">
        <span class="promo-code-input__initial-row-label" @click="$emit('initialised')"
          >Have a promo code?</span
        >
      </div>
    </template>
    <template v-else-if="isApplied">
      <div class="promo-code-input__applied-row">
        <div class="promo-code-input__applied-content">
          <span class="promo-code-input__applied-icon"></span>
          <span class="promo-code-input__applied-label">Code applied</span>
          <span class="promo-code-input__badge" @click.prevent.stop="onRemove">
            {{ appliedCode }}
            <button type="button" class="promo-code-input__remove-icon"></button>
          </span>
          <span class="promo-code-input__applied-amount"> +${{ appliedAmount }} </span>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="promo-code-input__row-label">Promo code</div>
      <div class="promo-code-input__row">
        <form-input
          v-model="localCode"
          class="promo-code-input__form-input"
          name="promoCode"
          placeholder="Enter code"
          :disabled="isLoading"
          :validation="hasError ? { $error: true } : null"
        />
        <button
          type="button"
          class="button button--inverted promo-code-input__apply-btn"
          @click.prevent.stop="onApply"
          :disabled="isLoading || !localCode.trim()"
        >
          <span v-if="isLoading" class="promo-code-input__spinner"></span>
          <span v-else>Apply</span>
        </button>
      </div>
      <div v-if="hasError" class="promo-code-input__error">
        <svg
          class="promo-code-input__error-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 12 12"
          width="12"
          height="12"
        >
          <circle cx="6" cy="6" r="5.5" stroke="currentColor" fill="none" />
          <line x1="6" y1="3.5" x2="6" y2="6.5" stroke="currentColor" stroke-linecap="round" />
          <circle cx="6" cy="8.5" r="0.5" fill="currentColor" />
        </svg>
        {{ errorMessage }}
      </div>
    </template>
  </div>
</template>

<script src="./promo-code-input.js"></script>
<style src="./promo-code-input.scss" lang="scss"></style>
